// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__r63M6","modal":"Modal_modal__DJDMv","close":"Modal_close__V34Fj","title":"Modal_title__3HkNf"};